import { mock } from '@lib/axios';

const list = Array(15)
  .fill(0)
  .map((v, i) => ({
    platformCode: `123456${i}`,
    platformName: `支付宝${i}`
  }));

mock.onGet('/api/admin/paymentPlatformConfig/query').reply(() => [200, { list }]);

mock.onPost('/api/admin/paymentPlatformConfig/add').reply(async (config) => {
  const { platformCode, platformName } = JSON.parse(config.data);
  list.unshift({
    platformCode,
    platformName
  });
  return [
    200,
    {
      code: 0,
      data: {},
      message: '',
      requestNo: ''
    }
  ];
});
